module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-paytable-up@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-paytable-up@2x.png
// module id = 639
// module chunks = 0